import axios from "axios";
import { axiosPlainConfig } from "@/config";
import { isObject } from "lodash";
const map = {
  platform: import.meta.env.VITE_APP_URL,
  damcorp: import.meta.env.VITE_DAMCORP_URL,
  bawaslu: import.meta.env.VITE_BAWASLU_URL,
  'pgd-omni': import.meta.env.VITE_PEGADAIAN_URL
};

const urlTemp = map[window.location.hostname.split('.')[0]];
const httpPlain = axios.create(axiosPlainConfig);

const requestHandler = (r) => {
  return r;
};

const responseHandler = (r) => {
  return r;
};

const errorHandler = (e) => {
  if (isObject(e)) {
    if (e.response.status === 401) {
      localStorage.removeItem("user");
      // window.location.href = import.meta.env.VITE_APP_URL;
      window.location.href = urlTemp;
    }
  }
  return Promise.reject(e);
};

httpPlain.interceptors.request.use(
  (r) => requestHandler(r),
  (e) => errorHandler(e)
);

httpPlain.interceptors.response.use(
  (r) => responseHandler(r),
  (e) => errorHandler(e)
);

export default httpPlain;
